import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const HtmlRunner = ({ html }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      const doc = iframeRef.current.contentDocument;
      doc.open();
      doc.write(html);
      doc.close();
    }
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      sandbox="allow-scripts allow-same-origin"
      style={{
        width: '100%',
        height: '400px',
        border: '1px solid #ccc',
      }}
      title="HTML Runner"
    />
  );
};

export default HtmlRunner;
HtmlRunner.propTypes = {
  html: PropTypes.string.isRequired,
};
